const NotFound = () => {
  return (
    <p
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "var(--text-lg)",
      }}
    >
      此頁面不存在 404🤫
    </p>
  );
};

export default NotFound;
